export const CarWashCardSkeleton = () => {
  return (
    <div className="w-72 bg-popupLight dark:bg-popupDark rounded-lg shadow-md p-0 animate-pulse">
      <div className="w-full h-48 bg-gray-300 dark:bg-gray-700 rounded-t-lg" />
      <div className="p-4 space-y-3">
        <div className="h-5 w-2/3 bg-gray-300 dark:bg-gray-700 rounded" />
        <div className="h-4 w-full bg-gray-300 dark:bg-gray-700 rounded" />
        <div className="h-4 w-3/4 bg-gray-300 dark:bg-gray-700 rounded" />
        <div className="h-5 w-1/3 bg-gray-300 dark:bg-gray-700 rounded mt-2" />
      </div>
    </div>
  );
};
